import { Observable } from 'rxjs';
import { DataSourceMeta, DocAnnotation, TextItem } from '../models';

export abstract class Loader {
    public abstract Dispose();
    public abstract GetPdf(): Observable<File>;
    public abstract GetPdfDataSource(): Observable<DataSourceMeta[]>;
    public abstract SavePdf(pdf: File): Observable<void>;
    public abstract GetTextItems(): Observable<TextItem[]>;
    public abstract GetAnnotations(): Observable<DocAnnotation[]>;
    public abstract GetSelectedStampId(): string;
}
